var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgResults(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z",
    fill: "#e1087e"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M19 10.5C19 6.9 16.1 4 12.5 4S6 6.9 6 10.5c0 3.5 2.7 6.3 6.2 6.5v5h1v-5c3.2-.4 5.8-3.1 5.8-6.5zM12.5 16c-3 0-5.5-2.5-5.5-5.5S9.5 5 12.5 5 18 7.5 18 10.5 15.5 16 12.5 16z",
    fill: "#fff"
  })));
}
export default SvgResults;